import PropTypes from 'prop-types';
import React, { Suspense } from 'react';
import { LabelHTML } from '../Label/Label';
import SeriesComparisonItem from './SeriesComparisonItem';
import dynamic from 'next/dynamic';
import Loader from '../../adapters/helpers/Loader';
import LazyLoad from 'react-lazy-load';
const Disclaimer = dynamic(() => import('../Disclaimer/Disclaimer'));

export default function SeriesComparison(props) {
    const {document: doc, products, selectedSeries, onClickCallback} = props;

    return (
    <LazyLoad offset={50} unmountIfInvisible={true}>
        <Suspense fallback={<Loader/>}>
        <div className="ob-series-comparison">
            <div className="ob-series-comparison__sizer">
                        <h2 className="ob-series-comparison__title">
                            <Suspense fallback={<Loader/>}>
                                <LabelHTML label={doc.fields.compareLabel} tokens={{seriesName: selectedSeries.fields.shortTitle}} />
                            </Suspense>
                        </h2>

                <ul className="ob-series-comparison__list">
                    {products.map((product, i) => (
                        <li key={i} className="ob-series-comparison__item">
                            <Suspense fallback={<Loader/>}>
                                <SeriesComparisonItem document={doc} product={product} onClickCallback={onClickCallback} />
                            </Suspense>
                        </li>
                    ))}
                </ul>
                {selectedSeries?.fields?.disclaimer &&
                    <Suspense fallback={<Loader/>}><Disclaimer document={selectedSeries?.fields?.disclaimer} /></Suspense>
                }
            </div>
        </div>
        </Suspense>
        </LazyLoad>
    );
}

SeriesComparison.propTypes = {
    document: PropTypes.any,
    products: PropTypes.any,
    selectedSeries: PropTypes.object,
    onClickCallback: PropTypes.func,
};
